const awsmobile = {
    Auth: {
        // REQUIRED - Amazon Cognito Region
        region: 'eu-north-1',

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'eu-north-1_0mwKcRbbV',

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: '54gd6buo5sqccprhc69reeksc0',
    }
};

export default awsmobile;
